import { useAxios } from 'src/hooks/use-axios';

export function useDeletePermissionGroup() {
  return useAxios(
    (axios, baseConfig, url: string) =>
      axios.request({
        method: 'DELETE',
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: false }
  );
}

export type DeletePermissionGroupRequest = ReturnType<
  typeof useDeletePermissionGroup
>;
